<ef-registration-presenter *ngIf="needsRegistration"
(SaveRegistration)="onSaveRegistration($event)"></ef-registration-presenter>
